import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-six-earning-tooltip",
  templateUrl: "./six-earning-tooltip.component.html"
})
export class SixEarningTooltipComponent implements OnInit {
  @Input() earning: any;
  constructor() {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component/six-earning-tooltip/six-earning-tooltip.component.ts